// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import ReactDOM from 'react-dom';
import Header from './header';
import Cell from './cell';
import Loading from 'react-loading';


import '../../../styles/taSpreadsheet.css';
export default class Spreadsheet extends React.Component {
    constructor(props) {
        super(props);
        this.tableContainerRef = React.createRef();
    }

    state = {
        columnOffset: 0,
        canShow: 0,
    }

    componentDidMount = () => {
        // Add an event listener to window, and call checkOverflow when the window is resized
        window.addEventListener('resize', this.checkOverflow);
        // Call checkOverflow to set the initial state
        this.checkOverflow();
    };

    componentWillUnmount = () => {
        // Remove the event listener when the component is unmounted
        window.removeEventListener('resize', this.checkOverflow);
    }

    componentDidUpdate = (prevProps) => {
        // Have the headers changed?  Recheck overflow
        if (prevProps.headers !== this.props.headers) {
            this.checkOverflow();
        }
    }

    checkOverflow = () => {
        // We need to get the total width available to the table. Each column is 200px wide. 
        // Get the table container... 
        const container = ReactDOM.findDOMNode(this.tableContainerRef.current);

        // What is the width of the container?
        const containerWidth = container.offsetWidth;
        // How many columns can we fit in the container? 
        const columns = Math.floor((containerWidth - 350) / 175);

        // Set the can show state
        this.setState({
            canShow: columns,
            isOverflowing: this.props.columnDefs.length > columns + 2
        });
    }

    render = () => {

        // Create an array of column index's we can show... 
        const visible = [0, this.props.columnDefs.length - 1, ...Array(Math.max(this.state.canShow, 0)).fill().map((_, i) => i + this.state.columnOffset + 1)];

        const leftIssueCount = this.props.headers.reduce((acc, header, i) => {
            if (i > this.state.columnOffset)
                return acc;

            // Get the header data and check for issues... 
            const data = header.data;
            if (!data) return acc;
            return acc += (data.errorCount??0 + data?.missing?1:0); 
        }, 0);
        const rightIssueCount = this.props.headers.reduce((acc, header, i) => {
            if (i < this.state.columnOffset + this.state.canShow + 1)
                return acc;

            // Get the header data and check for issues... 
            const data = header.data;
            if (!data) return acc;
            return acc += (data.errorCount??0 + data?.missing?1:0); 
        }, 0);

        return (
            <div style={{ position: 'relative', overflow: 'visible' }} ref={this.tableContainerRef}>
                {
                    this.props.loading ?
                        <div
                            className='ta-spreadsheet-loading'
                        >
                            <Loading 
                                type='bubbles'
                                color='var(--color-primary)'
                                size={100}
                            />
                        </div>
                        :
                        <>
                            <table className='ta-spreadsheet'>
                                <thead>
                                    {
                                        this.state.isOverflowing ? <>
                                            {
                                                this.state.columnOffset > 0 ?
                                                    <div className='spreadsheet-navigation-container left'>
                                                        {
                                                            leftIssueCount > 0 ?
                                                                <div className='spreadsheet-navigation-issue-count'>{leftIssueCount}</div> : ""
                                                        }
                                                        <div className='spreadsheet-navigation-start'
                                                            onClick={() => {
                                                                this.setState({ columnOffset: 0 });
                                                            }}
                                                        />
                                                        <div className='spreadsheet-navigation-back'
                                                            onClick={() => this.setState({ columnOffset: this.state.columnOffset - 1 })}
                                                        />
                                                    </div> : ""
                                            }
                                            {
                                                this.state.columnOffset + this.state.canShow < this.props.columnDefs.length - 2 ?
                                                    <div className='spreadsheet-navigation-container right'>
                                                        <div className='spreadsheet-navigation-next'
                                                            onClick={() => this.setState({ columnOffset: this.state.columnOffset + 1 })}
                                                        />
                                                        <div className='spreadsheet-navigation-end'
                                                            onClick={() => {
                                                                this.setState({ columnOffset: this.props.columnDefs.length - this.state.canShow - 2 });
                                                            }}
                                                        />
                                                        {
                                                            rightIssueCount > 0 ?
                                                                <div className='spreadsheet-navigation-issue-count'>{rightIssueCount}</div> : ""
                                                        }
                                                    </div> : ""
                                            }
                                        </> : ""
                                    }
                                    <tr className='spreadsheet-header-row'>
                                        {
                                            this.props.headers.map((header, i) => {
                                                if (!visible.includes(i)) {
                                                    return null;
                                                }
                                                // Get the column definition for this header...
                                                const columnDef = this.props.columnDefs.find((def) => def.key === header.columnKey);
                                                return <Header key={header.columnKey} {...header} {...columnDef} renderActionOpen={this.props.renderActionOpen} userEmail={this.props.userEmail} />
                                            })
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.props.rowDefs.map((rowDef, index) => {
                                            return (
                                                <tr
                                                    className='spreadsheet-row'
                                                    style={rowDef.style}
                                                >
                                                    {
                                                        this.props.columnDefs.map((columnDef, i) => {
                                                            if (!visible.includes(i)) {
                                                                return null;
                                                            }
                                                            const cell = this.props.cells.find((cell) => {
                                                                if (cell.rowKey === rowDef.key && cell.columnKey === columnDef.key) {
                                                                    return cell;
                                                                }
                                                                return false; 
                                                            });

                                                            return (
                                                                <Cell
                                                                    {...columnDef}
                                                                    {...cell}
                                                                    query={this.props.query}
                                                                />)
                                                        })
                                                    }
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </table>
                        </>
                }
            </div>
        )
    }
}